import * as MixpanelProfilePageActions from '@analytics/mixpanel/actions/ProfilePage';
import { CelebrityResponse } from '@api/Celebrities';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useState } from 'react';
import { I18N_PROFILE_CONTEXT, REQUEST_LIMIT_COUNT } from '../ProfileForm.constants';
import { LimitedRequestContainer, StarSVG } from './LimitedRequests.styles';

const LimitedRequests = ({ audioLimiting, videoLimiting, ...props }: CelebrityResponse): JSX.Element => {
  const router = useRouter();
  const { t } = useTranslation(I18N_PROFILE_CONTEXT);

  const buildState = useCallback(() => {
    if (!audioLimiting || !videoLimiting) return {};

    return videoLimiting.enabled && audioLimiting.enabled
      ? { messageType: '', quantity: videoLimiting.totalSlots + audioLimiting.totalSlots }
      : videoLimiting.enabled && !audioLimiting.enabled
      ? { messageType: t('video'), quantity: videoLimiting.totalSlots }
      : !videoLimiting.enabled && audioLimiting.enabled
      ? { messageType: t('audio'), quantity: audioLimiting.totalSlots }
      : { messageType: undefined, quantity: undefined };
  }, [t, audioLimiting, videoLimiting]);

  const [limitedSlots, setLimitedSlots] = useState<{ messageType?: string; quantity?: number }>(buildState());

  useEffect(() => {
    if (!audioLimiting || !videoLimiting) return;

    setLimitedSlots(buildState());
  }, [t, audioLimiting, videoLimiting, buildState]);

  const onClick = () => {
    MixpanelProfilePageActions.onTotalRequestLimitCardClicked({
      router,
      details: {
        celebrityName: props.slug,
        total: `${limitedSlots.quantity || ''}`,
        audioRemaining: audioLimiting.enabled ? `${audioLimiting.remainingSlots}` + '' : 'N/A',
        videoRemaining: videoLimiting.enabled ? `${videoLimiting.remainingSlots}` + '' : 'N/A',
      },
    });
  };

  if (limitedSlots.messageType === undefined || limitedSlots.quantity === undefined) return <></>;

  return (
    <LimitedRequestContainer onClick={onClick}>
      <StarSVG width={16} height={16} />
      {t(REQUEST_LIMIT_COUNT, {
        messageType: ' ' + limitedSlots.messageType,
      })}
    </LimitedRequestContainer>
  );
};

export default LimitedRequests;
